<template>
  <div class="projects-page">
    <h2>Active Projects</h2>
    <ProjectList
      :projects="activeProjects"
      :isActive="true"
    />

    <header @click="toggleInactives">
      <h2>Inactive Projects</h2>
      <KeyboardArrow :downArrow="showInactives" />
    </header>
    <div
      class="inactive-projects"
      :class="{ show: showInactives }"
    >
      <ProjectList :projects="inactiveProjects" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import ProjectList from '@/components/project/ProjectList.vue'
import KeyboardArrow from '@/components/assets/KeyboardArrow';
import { snapshotToArray } from '../../utilities/firebase.utilities';
import { sortBy } from '../../utilities/array.utilities';

export default {
  name: 'Projects',
  components: {
    KeyboardArrow,
    ProjectList
  },
  created() {
    this.getActiveProjects()
    this.getInactiveProjects()
  },
  data() {
    return {
      activeProjects: [],
      inactiveProjects: [],
      showInactives: false
    }
  },
  methods: {
    getActiveProjects() {
      const query = firebase.database().ref('projects').orderByChild('isActive').equalTo(true)
      query.on('value', (res) => {
        this.activeProjects = snapshotToArray(res)
        this.activeProjects = sortBy(this.activeProjects, 'name')
      })
    },
    getInactiveProjects() {
      const query = firebase.database().ref('projects').orderByChild('isActive').equalTo(false)
      query.on('value', (res) => {
        this.inactiveProjects = snapshotToArray(res)
        this.inactiveProjects = sortBy(this.inactiveProjects, 'name')
      })
    },
    toggleInactives() {
      this.showInactives = !this.showInactives
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/page';

.projects-page {
  padding: 0 8px;

  @media (min-width: 1024px) {
    padding: 0 75px;
  }

  header {
    @include flex(row, flex-start, flex-start);
  }

  h2 {
    margin: 0 8px;
    text-align: left;
    color: $gd-dark-gray;
    font-size: 18px;
    font-weight: normal;
  }
}
.inactive-projects {
  height: 0;
  overflow: hidden;

  &.show {
    height: auto;
  }

  .projects {
    opacity: .5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/Projects.vue